import Vue from 'vue'
import vueRouter from 'vue-router'
import Meetup from './components/Meetup'
import Home from './views/Home.vue'
import Meetups from './components/Meetups'
import videoPlayer from './components/videoPlayer'
import panel from './components/search-panel'
import Login from './components/Login'
import personalcenter from './components/personalcenter'
import CreateMeetup from './components/Discussion'
import register from './components/register'
import outlook from './components/outlook'
import Landing from './components/Landing'
/* eslint-disable */

Vue.use(vueRouter)

export default new vueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/meetups/:id',
      name: 'meetups',
      props: true,
      component: Meetup,
      meta: {
        requiresAuth: true // 添加该字段，表示进入这个路由是需要登录的
       },
    },
    {
      path: '/meetups',
      name: 'Meetups',
      component: Meetups,
    },
    {
      path: '/videoPlayer',
      name: 'videoPlayer',
      component: videoPlayer,
    },
    {
      path: '/searchpanel',
      name: 'panel',
      component: panel,
    },
    {
      path: '/personalcenter',
      name: 'personalcenter',
      component: personalcenter,
      meta: {
        requiresAuth: true // 添加该字段，表示进入这个路由是需要登录的
       },
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta: {
        requiresGuest: true // 添加该字段，表示进入这个路由是需要登录的
       },
    },
    {
      path: '/register',
      name: 'register',
      component: register,
    },
    {
      path: '/Discussion',
      name: 'Discussion',
      component: CreateMeetup,
      meta: {
        requiresAuth: true // 添加该字段，表示进入这个路由是需要登录的
       },
    },
    {
      path: '/outlook',
      name: 'outlook',
      component: outlook,
    },
    {
      path: '/Landing',
      name: 'Landing',
      component: Landing,
    }
  ]
    
})
